import { Outlet } from 'react-router-dom';
import ExtensionRoute from '../../modules/core/public/ExtensionRoute';

export default function ConsignmentRoutes() {
  return (
    <ExtensionRoute extensionId="consignment">
      <Outlet />
    </ExtensionRoute>
  );
}
